
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50 0.00012207C22.4 0.00012207 0 22.4001 0 50.0001C0 77.6001 22.4 100 50 100C77.6 100 100 77.6001 100 50.0001C100 22.4001 77.6 0.00012207 50 0.00012207ZM36.45 71.4501L18.5 53.5001C16.55 51.5501 16.55 48.4001 18.5 46.4501C20.45 44.5001 23.6 44.5001 25.55 46.4501L40 60.8501L74.4 26.4501C76.35 24.5001 79.5 24.5001 81.45 26.4501C83.4 28.4001 83.4 31.5501 81.45 33.5001L43.5 71.4501C41.6 73.4001 38.4 73.4001 36.45 71.4501Z","fill":"#20F36A"}})])
          )
        }
      }
    